export const useSxStyles = () => {
  return {
    text: {
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      marginTop: 'auto',
      marginBottom: 'auto',
      '& > *': {
        display: 'inline',
      },
    },
  };
};
